import Utils from "../basic/Utils";
import DitapMask from "./DitapMask";

class DitapMobileSelectPopup {
  constructor(parent) {
    if (parent instanceof Element) {
      this.parent = parent;
    } else {
      throw Error("DitapMobileSelectPopup parent type error");
    }
    this.wrapper = undefined;
    this.header = undefined;
    this.content = undefined;
    this.footer = undefined;
    this.closeBtn = undefined;
    this.mask = new DitapMask();

    this.init(); // 팝업 엘리먼트 생성
  }

  addTitle(titleTxt) {
    const title = document.createElement("h2");
    title.classList.add("ditap-popup-title");
    title.innerText = titleTxt;

    this.prependHeader(title);
  }

  /**
   * 헤더 영역 맨 앞에 요소 추가.<br>
   * Prepend element to header.
   * @param {Element} element 추가할 요소.<br>Element to add.
   */
  prependHeader(element) {
    if (element instanceof Element) {
      this.header.prepend(element);
    }
  }

  /**
   * 헤더 영역에 요소 추가.</br>
   * Append element to header.
   * @param {Element} element 추가할 요소.<br> Element to add.
   */
  appendHeader(element) {
    if (element instanceof Element) {
      this.header.append(element);
    }
  }

  /**
   * 헤더 영역의 자식 요소 제거.</br>
   * Remove children of header.
   * @param {Element} element 제거할 요소.<br>Element to remove.
   */
  removeHeader(element) {
    if (element instanceof Element) {
      this.header.removeChild(element);
    }
  }

  /**
   * 헤더 영역의 모든 자식 요소 제거.<br>
   * Remove all children of header.
   */
  removeAllHeader() {
    this.header.innerHtml = "";
  }

  /**
   * 컨텐츠 영역에 요소 추가.<br>
   * Append element to content.
   * @param {Element} element 추가할 요소.<br>Element to add.
   */
  appendContent(element) {
    if (element instanceof Element) {
      this.content.append(element);
    }
  }

  /**
   * 컨텐츠 영역 맨 앞에 요소 추가.</br>
   * Prepend element to content.
   * @param {Element} element 추가할 요소.<br>Element to add.
   */
  prependContent(element) {
    if (element instanceof Element) {
      this.content.prepend(element);
    }
  }

  /**
   * 컨텐츠 영역의 자식 요소 제거.</br>
   * Remove children of content.
   * @param {Element} element 제거할 요소.<br>Element to remove.
   */
  removeContent(element) {
    if (element instanceof Element) {
      this.content.removeChild(element);
    }
  }

  /**
   * 컨텐츠 영역의 모든 자식 요소 제거.</br>
   * Remove all children of content.
   */
  removeAllContent() {
    this.content.innerHtml = "";
  }

  /**
   * 푸터 영역에 요소 추가.<br>
   * Append element to footer.
   * @param {Element} element 추가할 요소.</br> Element to add.
   */
  appendFooter(element) {
    if (element instanceof Element) {
      this.footer.append(element);
    }
  }

  /**
   * 푸터 영역 맨 앞에 요소 추가.</br>
   * Prepend element to footer.
   * @param {Element} element 추가할 요소.</br>  Element to add.
   */
  prependFooter(element) {
    if (element instanceof Element) {
      this.footer.prepend(element);
    }
  }

  /**
   * 푸터 영역의 자식 요소 제거.</br>
   * Remove children of footer.
   * @param {Element} element 제거할 요소.</br> Element to remove.
   */
  removeFooter(element) {
    if (element instanceof Element) {
      this.footer.prepend(element);
    }
  }

  /**
   * 푸터 영역의 모든 자식 요소 제거.</br>
   * Remove all children of footer.
   */
  removeAllFooter() {
    this.footer.innerHtml = "";
  }

  /*
   * 팝업 초기화.<br>
   * Popup init.
   */
  init() {
    // 엘리먼트 생성
    const wrapper = document.createElement("div");
    wrapper.classList.add(
      "ditap-popup",
      "ditap-size-popup",
      "hide",
      "ditap-mobile-select-popup"
    );

    const header = document.createElement("div");
    header.classList.add("ditap-popup-header");
    const content = document.createElement("div");
    const closeBtn = document.createElement("button");
    closeBtn.classList.add("ditap-popup-close-btn");
    const btnWrap = document.createElement("div");
    btnWrap.classList.add("ditap-panel-btn-wrap");

    content.classList.add("ditap-popup-content");
    const footer = document.createElement("div");
    footer.classList.add("ditap-popup-footer");

    const contentWrapper = document.createElement("div");
    contentWrapper.classList.add("ditap-popup-content-wrap");

    // wrapper 안에 추가
    btnWrap.append(closeBtn);
    header.append(btnWrap);
    wrapper.append(header);
    contentWrapper.append(content);
    contentWrapper.append(footer);
    wrapper.append(contentWrapper);

    // set
    this.wrapper = wrapper;
    this.header = header;
    this.content = content;
    this.conetentWrapper = contentWrapper;
    this.footer = footer;
    this.closeBtn = closeBtn;
    this.btnWrap = btnWrap;

    wrapper.addEventListener("mouseover", Utils.hideLabelElement);
    wrapper.addEventListener("mouseout", Utils.showLabelElement);

    // 헤더 닫기 버튼
    this.closeBtn.addEventListener("click", () => {
      this.close();
    });
  }

  /*
   * 팝업 열기.</br>
   * Open popup.
   * @param {Element} element 매개변수가 없는 경우 wrapper 오픈.</br> element If no parameter is entered, open wrapper.
   */
  open(element) {
    this.isOpen = true;
    // 부모 자식으로 wrapper 추가
    if (this.parent instanceof Element) {
      this.parent.append(this.wrapper);
    }

    this.mask.open();

    this.mask.mask.classList.add("ditap-mobile-mask-2");
    if (element) {
      element.classList.remove("hide");
    } else {
      this.wrapper.classList.remove("hide");
    }
  }

  /*
   * 팝업 닫기.</br>
   * Close popup.
   * @param {Element} element 매개변수가 없는 경우 wrapper 오픈.</br>  If no parameter is entered, close wrapper.
   */
  close(element = undefined) {
    this.isOpen = false;
    // 부모 자식으로 wrapper 추가
    if (this.parent instanceof Element) {
      this.wrapper.remove();
    }
    this.mask.closeMobile();
    if (this.closeCallback) {
      this.closeCallback();
    }
    this.mask.mask.classList.remove("ditap-mobile-mask-2");

    if (element) {
      element.classList.add("hide");
    } else {
      this.wrapper.classList.add("hide");
    }
  }

  /**
   * 이 객체의 모든 리소스 제거.</br>
   * Remove all resources of this object.
   */
  destroy() {
    this.ditapPaneManager?.removePane(this.wrapper);
    if (this.wrapper instanceof Element) {
      this.wrapper.remove();
    }
    if (this.header instanceof Element) {
      this.header.remove();
    }
    if (this.content instanceof Element) {
      this.content.remove();
    }
    if (this.footer instanceof Element) {
      this.footer.remove();
    }
    if (this.closeBtn instanceof Element) {
      this.closeBtn.removeEventListener("click", () => {
        this.close();
      });
    }
    if (this.wrapper instanceof Element) {
      this.wrapper.removeEventListener("mouseover", Utils.hideLabelElement);
      this.wrapper.removeEventListener("mouseover", Utils.showLabelElement);
    }

    this.mask.mask.classList.remove("ditap-mobile-mask-2");
  }
}

export default DitapMobileSelectPopup;
